import {doc} from './docs.js';
import SynthControl from '../custom/SynthControl.js';

doc(
    "synthcontrol",
    {
    },
    "FUCK",
    () => 0,
    {
        inlets: 0
    }
);

export const synthcontrol = (object) => {
    let o = new SynthControl(object);
    object.needsLoad = true;
    return () => {
        o.sendADSRLevels();
        o.sendOscillatorLevels();
    };
};
